module.exports = __webpack_public_path__ + "static/media/acacia mall shot 03.aa1d056a.webp";